import React from 'react'
import Nav from '../../components/NavBar/Nav'
import Footer from '../../components/Footer/Footer'
import AllProjects from '../../components/AllProjects/AllProjects'

const index = () => {
  return (
    <div>
        <Nav/>
        <AllProjects/>
        <Footer/>
    </div>
  )
}

export default index